import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppraisalTemplateService } from '../../services/appraisal-template.service';
import { AppraisalTemplateDto } from '../../models/appraisal-template.dto';
import { QuestionType } from '../../models/question-type.enum';

@Component({
  selector: 'appraisal-template-view',
  templateUrl: './appraisal-template-view.component.html',
  styleUrls: ['./appraisal-template-view.component.scss'],
  standalone: false
})
export class AppraisalTemplateViewComponent implements OnInit {
  template: AppraisalTemplateDto | null = null;
  isLoading = false;

  QuestionType = QuestionType;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private templateService: AppraisalTemplateService
  ) {}

  ngOnInit(): void {
    const id = +this.route.snapshot.params['id'];
    this.loadTemplate(id);
  }

  private loadTemplate(id: number): void {
    this.isLoading = true;
    this.templateService.getById(id).subscribe({
      next: template => {
        this.template = template;
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  getQuestionTypeLabelKey(type: QuestionType | number | string): string {
    const questionType = this.normalizeQuestionType(type);
    const labels: Record<number, string> = {
      [QuestionType.Likert5]: 'LIKERT_5_SCALE',
      [QuestionType.FreeText]: 'FREE_TEXT',
      [QuestionType.YesNo]: 'YES_NO'
    };
    return questionType === null ? 'UNKNOWN' : ( labels[questionType] ?? 'UNKNOWN');
  }

  getQuestionTypeClass(type: QuestionType | number | string): string {
    const questionType = this.normalizeQuestionType(type);
    const classes: Record<number, string> = {
      [QuestionType.Likert5]: 'badge-info',
      [QuestionType.FreeText]: 'badge-secondary',
      [QuestionType.YesNo]: 'badge-warning'
    };
    return questionType === null ? 'badge-secondary' : ( classes[questionType] ?? 'badge-secondary');
  }

  private normalizeQuestionType(type: QuestionType | number | string): QuestionType | null {
    if (typeof type === 'number') {
      return type as QuestionType;
    }

    const value = String(type ?? '').trim().toLowerCase();
    if (!value) {
      return null;
    }

    if (/^\d+$/.test(value)) {
      return Number(value) as QuestionType;
    }

    const aliases: Record<string, QuestionType> = {
      likert5: QuestionType.Likert5,
      likert: QuestionType.Likert5,
      '5-point scale': QuestionType.Likert5,
      free_text: QuestionType.FreeText,
      'free text': QuestionType.FreeText,
      freetext: QuestionType.FreeText,
      text: QuestionType.FreeText,
      yes_no: QuestionType.YesNo,
      'yes/no': QuestionType.YesNo,
      yesno: QuestionType.YesNo
    };
    return aliases[value] ?? null;
  }

  onBack(): void {
    const targetRoute = this.route.parent ?? this.route;
    this.router.navigate(['./'], {
      relativeTo: targetRoute,
      queryParams: { tab: 'templates' }
    });
  }
}
